import { ReactNode } from 'react'

import { AccessibleFormWrapperStyles } from './AccessibleFormWrapperStyles'

interface AccessibleFormWrapperProps {
  children: ReactNode
  onSubmit: () => void
  className?: string
}

export const AccessibleFormWrapper = ({ children, onSubmit, className }: AccessibleFormWrapperProps) => {
  return (
    <AccessibleFormWrapperStyles>
      <form
        className={className}
        onSubmit={e => {
          e.preventDefault()
          onSubmit()
        }}
      >
        {children}
        <button type="submit" className="form-button-hidden" />
      </form>
    </AccessibleFormWrapperStyles>
  )
}
